import React from 'react'
import { CircularProgress } from '@material-ui/core'
import strings from 'strings'
import TaskRow from './TaskRow'

/** Renders the list of tasks (or a loading/empty state). */
const TaskList = ({ tasks, loading, onOpen, filter }) => {
    const t = strings.CT
    if (loading) {
        return <div className="ct-loading"><CircularProgress style={{ color: '#7B61FF' }} /></div>
    }
    if (!tasks || tasks.length === 0) {
        return (
            <div className="ct-list">
                <div className="ct-empty">
                    {filter === 'open' ? t.EMPTY_LIST : t.EMPTY_FILTERED}
                </div>
            </div>
        )
    }
    return (
        <div className="ct-list">
            {tasks.map(task => (
                <TaskRow key={task.id} task={task} onOpen={onOpen} />
            ))}
        </div>
    )
}

export default TaskList
